import React from 'react';
import styled from '@benzinga/themetron';
import { ContentFeedProps } from './ContentFeed';
import { NewsList } from './NewsList';
import { LatestNewsList } from './LatestNewsList';
import { NewsListWithLoadMore } from './NewsListWithLoadMore';
import { News, ParselyPostParams, StoryObject } from '@benzinga/basic-news-manager';
import { SimpleNewsQuery, SimpleNewsOptions } from '@benzinga/internal-news-manager';

export interface NewsListProps extends ContentFeedProps {
  link?: string;
  type?: 'default' | 'parsely_news_list' | 'latest_news_list';
  query_and_options: {
    query: SimpleNewsQuery;
    options: SimpleNewsOptions;
  };
  query: SimpleNewsQuery;
  parsely_query: ParselyPostParams;
  topStoriesFeed: any[];
}

export interface NewsListGroupProps {
  groups: NewsListProps[];
}

export interface NodeQuery {
  displayOutput: string;
  limit: number;
  tags: number[];
}

export const NewsListGroup = ({ groups }: NewsListGroupProps) => {
  return (
    <NewsListGroupWrapper className="news-list-group-wrapper">
      {groups.map((group, i) => {
        if (group?.title === 'Top Stories') {
          // should only for homepage
          const nodes = (group?.nodes ?? []) as News[];
          return (
            <NewsListWithLoadMore
              contentId="Top Stories"
              key={`news-list-group-item-${group.title}-${i}`}
              loadMoreDevice="mobile"
              nodes={group.topStoriesFeed ?? nodes}
              reachContent={group.reachContent}
              showCommentsIcon={false}
              showSponsoredContent={group.showSponsoredContent}
              title="Top Stories"
            />
          );
        } else if (group?.type === 'parsely_news_list') {
          const nodes = (group?.nodes ?? []) as News[];
          return (
            <NewsListWithLoadMore
              contentId="Popular Stories"
              key={`news-list-group-item-${group.title}-${i}`}
              loadMoreDevice="mobile"
              nodes={nodes}
              reachContent={group.reachContent}
              showCommentsIcon={false}
              showSponsoredContent={group.showSponsoredContent}
              title="Popular Stories"
            />
          );
        } else if (group?.type === 'latest_news_list') {
          const nodes = (group?.nodes ?? []) as StoryObject[];
          return (
            <LatestNewsList
              initialNodes={nodes}
              key={`news-list-group-item-${group.title}-${i}`}
              latestNewsQuery={group?.query ?? {}}
              reachContent={group.reachContent}
              showCommentsIcon={false}
              showSponsoredContent={group.showSponsoredContent}
            />
          );
        }
        return (
          <NewsList key={`news-list-group-item-${group.title}-${i}`} {...group} showCommentsIcon={false} />
        );
      })}
    </NewsListGroupWrapper>
  );
};

export const NewsListGroupWrapper = styled.div`
  &.news-list-group-wrapper {
    display: grid;
    gap: 32px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    @media (max-width: 640px) {
      gap: 32px;
      grid-column: 2;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .parsely-news-list,
    .latest-news-list {
      .news-block-header {
        display: flex;
        white-space: nowrap;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px ${({ theme }) => theme.colorPalette.neutral500};
        padding: 4px 0;
        margin-top: 12px;

        @media (max-width: 850px) {
          flex-wrap: wrap;
        }

        @media (max-width: 780px) {
          flex-wrap: unset;
        }

        .news-block-title {
          font-size: 1.2rem;
        }

        .news-block-tabs-list {
          min-width: 224px;
          button {
            text-transform: uppercase;
            color: ${({ theme }) => theme.colorPalette.gray600};
            font-size: ${({ theme }) => theme.fontSize.base};
            font-weight: ${({ theme }) => theme.fontWeight.semibold};
            border-bottom: 2px solid transparent;

            &.active {
              color: ${({ theme }) => theme.colorPalette.blue600};
              border-bottom: 2px solid;
            }
          }
          .divider {
            margin: 0 5px;
          }
        }
      }
    }
  }
`;
